export default __webpack_public_path__ + "BackgroundSoluce.d1eeb2f.png";